import { inject } from 'vue';
import { ApiPlugin } from '@/plugins';

export default class Accessibility {
  static getAccessibilitySettingsData() {
    const data = {
      name: window?.drupalSettings?.['sante_apf'],
    };
    if (!data) {
      console.error('Could not find the data in Accessibility Settings provided by the placeholder.');
      return {};
    }
    return data;
  }

  static async getAccessibilityApiData() {
    const placeNid = inject('place-nid');
    try {
      const response = await ApiPlugin.get(`/ajax/cps/mapping/${placeNid}`);
      return response.data;
    } catch (e) {
      console.error('Error fetching data from Accessibility \n', e);
      return [];
    }
  }
}
